import { motion } from "framer-motion";
import { Tv, Smartphone, Apple, Monitor, Cast } from "lucide-react";

const devices = [
  { icon: Tv, name: "Smart TV" },
  { icon: Cast, name: "Fire Stick" },
  { icon: Smartphone, name: "Android" },
  { icon: Apple, name: "iPhone / iPad" },
  { icon: Monitor, name: "PC" },
];

export const About = () => {
  return (
    <section id="que-es" data-testid="about-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-sm text-bp-primary uppercase tracking-[0.2em] font-semibold">Conócenos</span>
          <h2 className="font-heading text-3xl lg:text-5xl font-semibold tracking-tight mt-4">
            ¿Qué es BrothersPlus TV?
          </h2>
          <p className="mt-6 text-base lg:text-lg text-[#A3A3A3] leading-relaxed">
            <strong className="text-white font-semibold">BrothersPlus TV</strong> es una plataforma de entretenimiento
            compatible con Smart TV, Fire Stick, Android, iPhone, iPad y computadoras. Permite disfrutar de contenido
            desde cualquier lugar con una conexión estable a Internet.
          </p>
          <p className="mt-4 text-base text-[#A3A3A3] leading-relaxed">
            Con más de <strong className="text-white font-semibold">13,000 canales en vivo</strong>, <strong className="text-white font-semibold">22,000 películas</strong> y <strong className="text-white font-semibold">3,000 series</strong>,
            tendrás deportes, noticias, cine, series y programación infantil en un solo lugar. La activación es rápida y
            contarás con soporte personalizado por WhatsApp para instalar y aprovechar el servicio al máximo.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            {devices.map((d) => (
              <span
                key={d.name}
                className="inline-flex items-center gap-2 rounded-full border border-bp-border bg-bp-surface px-4 py-2 text-sm text-[#D4D4D4]"
              >
                <d.icon className="w-4 h-4 text-bp-primary" /> {d.name}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
